import { changeTagName } from '@sky-it-livedata/common-web-app-utils';

export function handleLGPHeadings() {
  const headings = document.querySelectorAll<HTMLHeadingElement>('h1,[data-h1]');

  for (const heading of headings) {
    heading.setAttribute('data-h1', 'true');

    if (isElementVisible(heading)) {
      changeTagName(heading, 'h1');
    } else {
      changeTagName(heading, 'h2');
    }
  }
}

function isElementVisible(element: HTMLElement) {
  if (element.offsetParent === null) {
    return false;
  }
  return true;
}
